import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck,faShuttleVan,faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import ListadoTable from './ListadoTable';
 

class Vehiculos extends Component {

  render() {
    let state = this.props.data
     
    return (     
      <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className='row'>
                      <div className='col-9'>

                        <h3 className="card-title">Listado de Vehiculos Disponibles</h3>
                      </div>
                      <div className='col-3 text-right'>
                        <button type="button" onClick={() => this.props.mostrarModalPedidosPendientes(null)} className='btn btn-sm btn-warning ' >
                          <FontAwesomeIcon icon={faTruck} className='mr-2'   />
                          Pedidos Pendientes
                        </button>
                      </div>
                    </div>

                  </div>

                  <div className="card-body">
                    <ListadoTable
                      registros={state.registros}
                      data={state}
                      funcionCrearRegistro={this.props.funcionCrearRegistro}
                      funcionIniciarDespacho={this.props.funcionIniciarDespacho}
                      
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) 

  }



}

export default Vehiculos;
